<app-header *ngIf="showComponents"></app-header>

<router-outlet></router-outlet>

<app-footer *ngIf="showComponents" class="footer mt-auto py-3 bg-black"></app-footer>